import { useTranslation } from '@wix/fe-essentials/react';
import { convertElementStatusToBooleanStatus, RuleElement } from '@wix/rules-panel-ui';
import React, { useCallback } from 'react';
import { BiCtaNames } from '../../../bi/types';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useHandleElementClick } from '../../../hooks/use-handle-element-click';
import { HeadingStructureRuleContent } from './heading-structure-rule-content/shared/heading-structure-rule-content';
import { HeadingStructureRuleHeader } from './heading-structure-rule-header';
import { decodeHtmlEntities } from './utils/decode-html-entities';
export const HeadingStructureRule = _ref => {
  let {
    status,
    isOpen,
    headingDefinition,
    headingContent,
    onClickApply,
    onClickCancel,
    toggleElement,
    failedReason,
    showLoader,
    elementIndex,
    id,
    contentRef,
    headerRef,
    isGeneric,
    pageId
  } = _ref;
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const onStatusChange = useCallback(() => {
    biLogger.elementStatusChange({
      index: elementIndex,
      status,
      value: headingDefinition
    });
  }, [biLogger, elementIndex, headingDefinition, status]);
  const {
    handleClickElement
  } = useHandleElementClick({
    isOpen,
    onOpenElement: () => biLogger.taskElementCtaClick({
      ctaName: BiCtaNames.Edit,
      index: elementIndex,
      status
    }),
    toggleElement
  });
  return /*#__PURE__*/React.createElement(RuleElement, {
    contentComponent: /*#__PURE__*/React.createElement("div", {
      ref: contentRef
    }, /*#__PURE__*/React.createElement(HeadingStructureRuleContent, {
      dataHook: isGeneric ? 'generic' : 'regular',
      failedReason: failedReason,
      headingDefinition: headingDefinition ?? 'p',
      id: id,
      index: elementIndex,
      isGeneric: isGeneric,
      pageId: pageId,
      showLoader: showLoader,
      status: status,
      onClickApply: onClickApply,
      onClickCancel: onClickCancel
    })),
    headerComponent: /*#__PURE__*/React.createElement("div", {
      ref: isOpen ? headerRef : null
    }, /*#__PURE__*/React.createElement(HeadingStructureRuleHeader, {
      headingContent: decodeHtmlEntities(headingContent),
      headingDefinition: headingDefinition,
      status: convertElementStatusToBooleanStatus(status)
    })),
    iconButtonAriaLabel: t('accessibility-wizard.common.edit.aria-label'),
    iconButtonToolTip: t('accessibility-wizard.common.edit'),
    id: id,
    isOpen: isOpen,
    status: status,
    onClick: handleClickElement,
    onStatusChange: onStatusChange
  });
};
//# sourceMappingURL=heading-structure-rule.js.map